<template>
  <header>
    <div id="main-menu" class="main-menu-container1">
      <div class="main-menu">
        <div class="container">
          <div class="navbar-default">
            <div class="navbar-header float-left">
              <a class="navbar-brand text-uppercase" href="/index" style="height: 64px;display: flex; align-items: center;"><img :src="logo2Src" alt="logo"></a>
            </div>

            <k-login></k-login>

            <nav class="navbar-menu float-right">
              <div class="nav-menu ul-li">
                <li style="color: transparent;">
                </li>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import Cookies from 'js-cookie'
import { ProjectSettings } from '@/views/base/base.js'

export default {
  name: 'jxsz-header',
  props: {
  },
  data() {
    return {
      projectName: ProjectSettings.Name,
      telephone: ProjectSettings.Telephone,
      logoSrc: ProjectSettings.LogoURL,
      logo2Src: ProjectSettings.Logo2URL,
      NewHomePage: ProjectSettings.NewHomePage,
      displayName: null,
      JfQRCodeURL: ProjectSettings.JfQRCodeURL
    }
  },
  mounted() {
    this.displayName = Cookies.get('DisplayName');
  },
  methods: {
    onIndex() {
      this.$router.push({ name: 'index' });
    },
    onSupermarket() {
      this.$router.push({ name: 'supermakrket' });
    },
    toIndexSection(id) {
      console.log('path', this.$route.path);
      if (this.$route.path !== '/index') {
        this.$router.push({ name: 'index', query: { toSection: id } });
      } else {
        $('html,body').animate({ scrollTop: $('#' + id).offset().top }, 1000);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.header_gradient {
  padding: 24px 0px 69px 0;
  position: relative;
  background-image: linear-gradient(
    to right,
    rgb(1, 166, 253) 0%,
    rgb(23, 208, 207) 51%,
    rgb(1, 166, 253) 100%
  );
  -webkit-transition: 0.3s all ease-in-out;
  -o-transition: 0.3s all ease-in-out;
  transition: 0.3s all ease-in-out;
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }
  .navbar-default {
    display: flex;
    justify-content: space-between;
    margin-right: 20px;
    align-items: center;
    .header-info li {
      margin-left: 35px;
    }
    .nav-menu-4 {
      z-index: 2;
      .nav-menu {
        ul {
          margin: 0 10px;
          display: flex;
          justify-content: space-between;
        }
        li {
          a {
            font-size: 15px;
            font-weight: bold;
            -webkit-transition: 0.3s all ease-in-out;
            -o-transition: 0.3s all ease-in-out;
            transition: 0.3s all ease-in-out;
          }
          a:after {
            color: #00eab2;
            background-size: 0;
          }
          a:hover {
            color: #00eab2;
            background-color: #fff;
          }
        }
      }
    }
  }
}
.header_gradient.full-width-menu {
  position: fixed;
  width: 100%;
  -webkit-transition: 0.3s all ease-in-out;
  -o-transition: 0.3s all ease-in-out;
  transition: 0.3s all ease-in-out;
  margin-top: -100px;
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/views/home/jxsz/header.vue